/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PipelinesChooser_team$ref = any;
export type PipelinesChooserQueryVariables = {|
  team: string,
  pipelineAddSearch?: ?string,
  teamSelector?: ?any,
|};
export type PipelinesChooserQueryResponse = {|
  +team: ?{|
    +$fragmentRefs: PipelinesChooser_team$ref
  |}
|};
export type PipelinesChooserQuery = {|
  variables: PipelinesChooserQueryVariables,
  response: PipelinesChooserQueryResponse,
|};
*/


/*
query PipelinesChooserQuery(
  $team: ID!
  $pipelineAddSearch: String
  $teamSelector: TeamSelector
) {
  team(slug: $team) {
    ...PipelinesChooser_team_3YqxUw
    id
  }
}

fragment PipelinesChooser_team_3YqxUw on Team {
  id
  slug
  organization {
    pipelines(search: $pipelineAddSearch, first: 10, order: RELEVANCE, team: $teamSelector) {
      edges {
        node {
          id
          name
          repository {
            url
          }
        }
      }
    }
    id
  }
  permissions {
    teamPipelineCreate {
      allowed
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pipelineAddSearch"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "team"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamSelector"
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "team"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelinesChooserQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "pipelineAddSearch",
                "variableName": "pipelineAddSearch"
              },
              {
                "kind": "Variable",
                "name": "teamSelector",
                "variableName": "teamSelector"
              }
            ],
            "kind": "FragmentSpread",
            "name": "PipelinesChooser_team"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "PipelinesChooserQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "order",
                    "value": "RELEVANCE"
                  },
                  {
                    "kind": "Variable",
                    "name": "search",
                    "variableName": "pipelineAddSearch"
                  },
                  {
                    "kind": "Variable",
                    "name": "team",
                    "variableName": "teamSelector"
                  }
                ],
                "concreteType": "PipelineConnection",
                "kind": "LinkedField",
                "name": "pipelines",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PipelineEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pipeline",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Repository",
                            "kind": "LinkedField",
                            "name": "repository",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamPermissions",
            "kind": "LinkedField",
            "name": "permissions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Permission",
                "kind": "LinkedField",
                "name": "teamPipelineCreate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allowed",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0cdf46d7d5d797734252a179513d886d",
    "id": null,
    "metadata": {},
    "name": "PipelinesChooserQuery",
    "operationKind": "query",
    "text": "query PipelinesChooserQuery(\n  $team: ID!\n  $pipelineAddSearch: String\n  $teamSelector: TeamSelector\n) {\n  team(slug: $team) {\n    ...PipelinesChooser_team_3YqxUw\n    id\n  }\n}\n\nfragment PipelinesChooser_team_3YqxUw on Team {\n  id\n  slug\n  organization {\n    pipelines(search: $pipelineAddSearch, first: 10, order: RELEVANCE, team: $teamSelector) {\n      edges {\n        node {\n          id\n          name\n          repository {\n            url\n          }\n        }\n      }\n    }\n    id\n  }\n  permissions {\n    teamPipelineCreate {\n      allowed\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3574bd9fb16c4d0231e06801143ba7ba';

module.exports = node;
